import { useId } from "react";

export type FolderIconProps = {
  /**
   * Rendered edge length in px (the glyph is square). Defaults to 33. Ignored
   * when {@link fill} is set.
   */
  size?: number;
  /** When true, the glyph fills its container (100% × 100%) instead of a fixed size. */
  fill?: boolean;
};

/**
 * The published-space folder glyph: a dark disc with a white folder and a soft
 * drop shadow. Inlined as a component (rather than a static `<img>`) so it needs
 * no network request and can size to the row; the shadow filter gets a unique id
 * per instance so multiple rows don't share (and clip against) one another's
 * filter region.
 */
export function FolderIcon({ size = 33, fill = false }: FolderIconProps) {
  const filterId = `folderShadow-${useId().replace(/:/g, "")}`;
  return (
    <svg
      width={fill ? "100%" : size}
      height={fill ? "100%" : size}
      viewBox="0 0 39 39"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable={false}
    >
      <defs>
        <filter
          id={filterId}
          x="0"
          y="0"
          width="39"
          height="39"
          filterUnits="userSpaceOnUse"
        >
          <feOffset in="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g transform="translate(4.5 4.5)">
        <g
          transform="matrix(1, 0, 0, 1, -4.5, -4.5)"
          filter={`url(#${filterId})`}
        >
          <circle
            cx="15"
            cy="15"
            r="15"
            transform="translate(4.5 4.5)"
            fill="#44555c"
          />
        </g>
        <path
          d="M1.75,44.25h10.5A1.752,1.752,0,0,0,14,42.5v-7a1.752,1.752,0,0,0-1.75-1.75H8.162a1.751,1.751,0,0,1-1.239-.511L6.2,32.511A1.751,1.751,0,0,0,4.96,32H1.75A1.752,1.752,0,0,0,0,33.75V42.5A1.752,1.752,0,0,0,1.75,44.25Z"
          transform="translate(8 -23.125)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
